import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=0f8278dc"
import script from "./FileInput.vue?vue&type=script&lang=ts"
export * from "./FileInput.vue?vue&type=script&lang=ts"
import style0 from "../inputs.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./FileInput.vue?vue&type=style&index=1&id=0f8278dc&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports